import React, { useState, useRef } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './contact.css'
// import '../home/home.css'
// import Footer from '../footer/footer';

export default function ContactPage({theme}) {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const form = useRef();
  const backEnd = process.env.REACT_APP_BACKEND_URL;
  const API_KEY_EMAIL = process.env.REACT_APP_API_KEY_EMAIL;


  const sendEmail = (fullName, email, phone, subject, msg) => {
    
    // Define toast styles based on the theme
    const toastStyle = theme === 'light-theme'
      ? {
          backgroundColor: '#816aff', // Light mode background
          color: '#ffffff',           // Light mode text
        }
      : {
          backgroundColor: '#379cf6', // Dark mode background
          color: '#ffffff',           // Dark mode text
        };

    // Display a loading toast while sending the email
    const loadingToast = toast.loading("Sending your message...", {
      position: "bottom-right",
      style: toastStyle,
    });

    // Simulate email sending
    fetch(`${backEnd}/email/`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', "X-API-Key": API_KEY_EMAIL },
      body: JSON.stringify({ full_name: fullName, email, phone, subject, msg }),
    })
      .then(response => response.json())
      .then(result => {
        toast.dismiss(loadingToast);
        if (result.success) {
          toast.success("Message sent successfully!", { position: "bottom-right", style: toastStyle });
        } else {
          toast.error("Something went wrong! Please try again later.", { position: "bottom-right", style: toastStyle });
        }
      })
      .catch(err => {
        console.error('Error:', err);
        toast.dismiss(loadingToast);
        toast.error("Something went wrong! Please try again later.", { position: "bottom-right", style: toastStyle });
      });    
  };

  
  const handleSubmit = (e) => {
    e.preventDefault();
    if (fullName && email && phone && subject && message) {
      sendEmail(fullName, email, phone, subject, message);
      e.target.reset();
      setFullName('');
      setEmail('');
      setPhone('');
      setSubject('');
      setMessage('');
    } else {
      toast.error("Please fill out all fields before submitting.", { position: "bottom-right" });
    }
  };

  return (
    <>
    <div className='section container' id='contact'>
    <div className='contactPage'>
      <section className="contact">
        <h2>Contact us!</h2>
        <form ref={form} onSubmit={handleSubmit} >
          {/* Form fields */}
          <div className="input-box">
            <div className="input-field field">
              <input
                type="text"
                placeholder="Full Name"
                className="item"
                value={fullName}
                onChange={e => setFullName(e.target.value)}
                autoComplete="off"
                name='user_name'
                />
            </div>
            <div className="input-field field">
              <input
                type="text"
                placeholder="Email"
                className="item"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="off"
                name='user_email'
                />
            </div>
          </div>
          <div className="input-box">
            <div className="input-field field">
              <input
                type="text"
                placeholder="Phone Number"
                className="item"
                value={phone}
                onChange={e => setPhone(e.target.value)}
                autoComplete="off"
                name='user_phone'
                />
            </div>
            <div className="input-field field">
              <input
                type="text"
                placeholder="Subject"
                className="item"
                value={subject}
                onChange={e => setSubject(e.target.value)}
                autoComplete="off"
                name='subject'
                />
            </div>
          </div>
          <div className="textarea-field field">
            <textarea
              cols="30"
              rows="10"
              className="item"
              placeholder="Your Message"
              value={message}
              onChange={e => setMessage(e.target.value)}
              autoComplete="off"
              name='message'
              ></textarea>
          </div>
          <button type="submit">Send Message</button>
        </form>
        <ToastContainer />
      </section>
      
    </div>
    </div>
    {/* <Footer /> */}
    </>
  );
}
